<template>
  <div class="view-visit">
    <v-container fluid class="wrap-container d-flex justify-space-between" v-if="visit">
      <v-col cols="12" style="padding: 0;">
        <v-row class="justify-space-between mx-0 my-0 user-info-panel" style="padding-bottom: 30px;">
          <v-col cols="9" style="padding: 0">
            <v-card class="visit-card-main-data">
              <v-card-text>
                <div class="d-flex align-center justify-space-between" style="border-bottom: 1px solid #E2E8F0; padding-bottom: 6px;">
                  <div class="d-flex align-center view-visit__header-status">
                    <span class="status-title">Evaluation</span>
                    <v-tooltip right :open-on-hover="false" v-model="showDescriptionStatus">
                      <template v-slot:activator="{}">
                        <div v-show="visit.status !== 'None'"
                             @click="showStatusDescription">
                          <status v-if="getStatusCodeName[visit.status]"
                                  :style="{
                                backgroundColor: getStatusCodeName[visit.status]?.background || '#EDF2F7',
                                color: getStatusCodeName[visit.status]?.text || '#A0AEC0'
                              }">
                            {{getStatusCodeName[visit.status].name}}
                          </status>
                        </div>
                      </template>
                      <div style="display: block;max-width: 300px;">{{getStatusCodeName[visit.status] ? getStatusCodeName[visit.status].description() : '-'}}</div>
                    </v-tooltip>
                  </div>
                  <div class="visit-controls">
                    <div class="d-flex align-center price-model-select">
                      <v-menu offset-y :disabled="['Completed', 'Closed'].includes(visit.status)">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="#FFFFFF"
                            :disabled="['Completed', 'Closed'].includes(visit.status)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" style="width: 18px">
                                  <Img :src="getImgWithExt(['icons', 'dollar-icon', 'svg'])" width="18px" />
                                </div>
                              </template>
                              <span>Show Price as</span>
                            </v-tooltip>
                            <span style="color: #16192C; font-size: 12px; text-transform: none; margin-right: auto">{{priceModel.name}}</span>
                            <Img  v-if="!['Completed', 'Closed'].includes(visit.status)"
                                  :src="getImgWithExt(['icons', 'select-arrow', 'svg'])" />
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(item, index) in patientOrderMethods"
                            :key="index"
                          >
                            <v-list-item-title style="cursor:pointer;" @click="updatePriceModel({ data: item }, priceModel.name)">{{ item.name }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>

                      <div class="visit-controls__supply-days" :class="{'disabled': ['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)}">
                        <div style="display: flex; align-items: center; column-gap: 10px" @click="openChangeDaysSupplModal">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" style="width: 18px">
                                <Img :src="getImgWithExt(['icons', 'supply-days', 'svg'])" width="18px" />
                              </div>
                            </template>
                            <span>Supply</span>
                          </v-tooltip>
                          <span
                            class="days-60"
                            :class="{'disable-days': ((tabs[componentInd].component === 'results' || tabs[componentInd].component === 'results_2') && (visit.finishedOn || ['InProtocol', 'NeedProduct', 'Completed', 'ProtocolEnding'].includes(visit.status))) || ['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)}">{{visit.supplyDays}} days</span>
                          <Img v-if="!['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                               :src="getImgWithExt(['icons', 'select-arrow', 'svg'])" />
                        </div>
                      </div>

                      <v-menu right buttom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="icon-more" v-bind="attrs" v-on="on">
                            <Img :src="getImgWithExt(['icons', 'more-icon', 'svg'])" width="24px" />
                          </v-btn>
                        </template>
                        <v-list max-width="240" class="more-menu">
                          <div :disabled="['InProtocol', 'Completed', 'Closed', 'NeedProduct', 'ProtocolEnding'].includes(visit.status)"
                               @click="openModalResetGrid">
                            <Img :src="getImgWithExt(['icons', 'reset', 'svg'])" width="20px" />
                            <span style="color: #425466">Reset grid</span>
                          </div>
                          <div v-if="!['NeedProduct', 'InProtocol', 'Completed', 'ProtocolEnding'].includes(visit.status)"
                               @click="openModalConfirmationDeleteVisit">
                            <Img :src="getImgWithExt(['icons', 'basket-red', 'svg'])" width="20px" />
                            <span style="color: #425466">Delete Evaluation</span>
                          </div>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>
                </div>
                <div class="main-row d-flex justify-space-between mt-2">
                  <div class="full-name-avatar">
                    <div class="full-name-avatar__avatar" @click="openPatientDetails">
                      <v-avatar size="46">
                        <img v-if="visit.patient.profileAvatar" :src="visit.patient.profileAvatar" :alt="visit.patient.firstName" />
                      </v-avatar>
                    </div>
                    <div class="full-name-avatar__full-name">
                      <div class="d-flex align-center">
                        <span class="fio mr-2" @click="openPatientDetails">{{visit.patient.firstName}} {{visit.patient.lastName}}</span>
                        <div class="d-flex">
                          <v-tooltip top v-if="visit.patient.vegetarian">
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" class="mr-2" style="width: 30px">
                                <Img :src="getImgWithExt(['icons', 'vegan_icon', 'svg'])" />
                              </div>
                            </template>
                            <span>Patient is Vegetarian</span>
                          </v-tooltip>
                          <v-tooltip top v-if="visit.patient.glutenFree">
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" class="mr-2" style="width: 30px">
                                <Img :src="getImgWithExt(['icons', 'gluten_icon', 'svg'])" />
                              </div>
                            </template>
                            <span>Patient is Gluten Free</span>
                          </v-tooltip>
                          <v-tooltip top v-if="visit.patient.registerPortal">
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" class="mr-2" style="width: 30px">
                                <Img :src="getImgWithExt(['icons', 'portal_regestreted_icon', 'svg'])" />
                              </div>
                            </template>
                            <span>Patient Portal Registered</span>
                          </v-tooltip>
                          <v-tooltip top v-if="visit.patient.lead" >
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon color="primary" v-bind="attrs" v-on="on">mdi-human-queue</v-icon>
                            </template>
                            <span>Patient has leads</span>
                          </v-tooltip>
                        </div>
                      </div>
                      <div class="patient-parameters">
                        <div class="d-flex patient-parameters__block">
                          <div v-if="patient && patient.sex" class="patient-parameters__value">
                            {{ patient.sex }}<span v-if="patient && patient.age">,</span>
                          </div>
                          <div v-if="patient && patient.age" class="patient-parameters__value">{{ patient.age || '' }} years</div>
                        </div>
                        <div v-if="patient && patient.weight" class="d-flex patient-parameters__block">
                          <span class="separator">·</span>
                          <div class="patient-parameters__title">Weight</div>
                          <div class="patient-parameters__value">{{ patient.weight }} lb</div>
                        </div>
                        <div v-if="patient && patient.height" class="d-flex patient-parameters__block">
                          <span class="separator">·</span>
                          <div class="patient-parameters__title">Height</div>
                          <div class="patient-parameters__value">{{ formatHeight(patient.height) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="last-visit">
                    <span>Evaluation date</span>
                    <div class="last-visit__date">
                      <div class="btn-date" :class="{'disabled': ['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)}">
                        <span class="btn-date__text">{{$moment(visitDate).format('MM/DD/YYYY')}}</span>
                        <datepicker
                          ref="datepicker"
                          style="position: absolute;top: 0;left: 0;opacity: 0;"
                          :min="isShowMinDate === 'true' ? nowDate : null"
                          @date:update="updateVisitDate"
                          :show-icon=false
                          :value="visitDate"
                        />
                        <DateIcon
                          style="position: absolute; right: 16px; top: 11px; cursor: pointer;"
                          @click="openDatePicker"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="3" style="padding: 0" class="visit-info">
            <v-row class="mx-0 my-0" style="height: 100%">
              <div v-if="getVisitControlConfig(visit)?.class?.toLowerCase() === 'closed'"
                   class="visit-info__closed">
                <p>The visit is finalized.</p>
                <p>All activities were completed</p>
              </div>
              <template v-else>
                <Button btn-bg="dark-green"
                        width="100%"
                        height="48px"
                        :disabled="isProcessDisabled"
                        class="visit-controls__main-button"
                        :class="getVisitControlConfig(visit)?.class"
                        style="width: 100%; margin-left: 35px; font-size: 14px;"
                        dark
                        @click="processVisit"
                        :styles="{ 'border-radius': '16px' }">
                  <span>{{ getButtonTitleWithCondition(visit) }}</span>
                </Button>
                <div style="margin-left: 35px; color: #718096;" class="mt-3 visit-info__text">
                  {{ getVisitControlConfig(visit)?.description }}
                </div>
              </template>
            </v-row>
          </v-col>
        </v-row>

        <!--new block header-->
        <v-row class="mx-0 my-0">
          <v-col class="px-0 py-0" style="position: relative">
            <Tabs :items="tabs" @update:tab="tab" :tab-index="tabIndex" left :dividerHeight="'20px'"
                  :isElevation="tabs[componentInd].component === 'survey' || tabs[componentInd].component === 'results' || tabs[componentInd].component === 'results_2'"
                  :isHiddenBg="tabs[componentInd].component === 'receipt' || tabs[componentInd].component === 'reports'">
              <template v-slot:sliderColor>
                <v-tabs-slider color="#008C89"></v-tabs-slider>
              </template>
              <template v-slot:newLineControlForAllTabs>
<!--                <div v-if="tabs[componentInd].component === 'blood' || tabs[componentInd].component === 'blood_old'">-->
                <div v-if="tabs[componentInd].component === 'blood'">
                  <div class="wrapper-blood-control">
                    <div class="wrapper-blood-control__block">
                      <div class="legend blood-lab">
                        <span class="legend-text">
                          Above
                         <LabAboveIcon />
                        </span>
                        <span class="legend-text bold">- Lab -</span>
                        <span class="legend-text">
                          <LabBelowIcon />
                          Below
                        </span>
                      </div>
                      <div class="legend blood-optimal">
                        <span class="legend-text">
                          Above
                        <OptimalAboveIcon />
                        </span>
                        <span class="legend-text bold">- Optimal -</span>
                        <span class="legend-text">
                          <OptimalBelowIcon />
                          Below
                        </span>
                      </div>
                    </div>
                    <div class="wrapper-blood-control__block">
                      <div class="blood-draw-date">
                        <span class="blood-draw-date__label">Blood Draw date</span>
                        <div class="blood-draw-date__date">
                          <span style="color: #1A202C; font-weight: 500; font-size: 14px">{{$moment(bloodData.bloodTestDate).format('MM/DD/YYYY')}}</span>
                          <datepicker
                            ref="datepicker"
                            v-if="!bloodData.isReadOnly"
                            style="position: absolute;top: 0;left: 0;opacity: 0;"
                            @date:update="updateBloodDate"
                            :show-icon=false
                            :value="bloodData.bloodTestDate"
                          />
                          <DateIcon
                            style="position: absolute; right: 16px; top: 11px; cursor: pointer;"
                            @click="openDatePicker"
                          />
                        </div>
                      </div>
                      <v-checkbox
                        color="#0A1F44"
                        label="Fasting"
                        :disabled="bloodData.isReadOnly"
                        :value="bloodData.isFasting"
                        v-model="bloodIsFasting"
                      ></v-checkbox>
                      <Button
                        v-if="hasDocumentsAccess"
                        class="btn-white"
                        @click="openImportModal"
                      >
                        Import & Files
                        <span v-if="bloodData.importSessions !== undefined && bloodData.importSessions !== null">
                          {{ bloodData.importSessions }}
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:[`${tabs[componentInd].component}`]>
                <component ref="currentTabComponent"
                           :elevation="2"
                           :orderMethod="priceModel"
                           :isUpdateResults="isUpdateResults"
                           :isUpdateSurvey="isUpdateSurvey"
                           :isUpdateDaysSupply="isUpdateDaysSupply"
                           :isUpdateVisit="isUpdateVisit"
                           :bloodIsFasting="bloodIsFasting"
                           @updateIsUpdateVisit="isUpdateVisit = $event"
                           @updateIsUpdateDaysSupply="isUpdateDaysSupply = $event"
                           @updateIsUpdateResults="isUpdateResults = $event"
                           @updateOrderMethod="updateOrderMethod"
                           @updateSurveySummary="updateSurveySummary"
                           @updateIsUpdateSurvey="isUpdateSurvey = $event"
                           :is="tabs[componentInd].component"
                           @changeTab="changeTab"></component>
              </template>
            </Tabs>

            <div
              class="d-flex flex-grow-1 justify-end align-center mb-1"
              style="column-gap: 10px; position: absolute; top: 0; right: 0">

              <div v-if="tabs[componentInd].component === 'results' || tabs[componentInd].component === 'results_2'"
                   class="buttons-wrapper"
              >
                <Button
                  class="btn-supplement"
                  v-if="!isVisitDisabled"
                  @click="openResult"
                >
                  <span class="title-btn">+  Supplements</span>
                </Button>
                <v-menu
                  v-if="visit.status !== 'Completed' && visit.previousResultsExist"
                  v-model="isDropdownVisible"
                  offset-y
                  attach
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="btn-customize-dropdown"
                      color="#E4ECF7"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span class="title-btn">+  Protocol</span>
                      <ChevronBlackIcon class="icon icon-arrow" :class="{ 'rotate': isDropdownVisible }" />
                    </v-btn>
                  </template>

                  <v-list class="dropdown-list">
                    <Button
                      :disabled="isVisitDisabled"
                      @click="openShowPreviousProtocol"
                    >
                      <PlusIcon />
                      <span class="title-btn">Previous Protocol</span>
                    </Button>
                    <Button
                      :disabled="isVisitDisabled"
                      v-if="visit.status !== 'Completed'"
                      @click="openShowProtocol"
                    >
                      <PlusIcon />
                      <span class="title-btn">Protocol</span>
                    </Button>
                  </v-list>
                </v-menu>

                <Button
                  v-else-if="visit.status !== 'Completed'"
                  class="btn-protocol"
                  :disabled="isVisitDisabled"
                  @click="openShowProtocol">
                  <span class="title-btn">+  Protocol</span>
                </Button>
              </div>

              <Button v-if="visit.showMarkForReview && tabs[componentInd].component === 'survey'"
                      class="btn-white"
                      @click="openConfirmationDialog">
                <InfoIcon class="mr-2" />
                Mark for Review
              </Button>

              <Button v-if="!surveyReadOnly && (tabs[componentInd].component === 'survey' || tabs[componentInd].component === 'results' || tabs[componentInd].component === 'results_2')"
                      class="btn-survey"
                      @click="openSurveyDialog"
              >
                <div class="d-flex align-center" style="column-gap: 20px">
                  <span class="text">Survey Summary</span>
                  <span class="amount">{{ visit.surveyScore }}</span>
                </div>
              </Button>

              <RefreshIcon
                v-if="
                !isVisitDisabled &&
                ['survey', 'results', 'results_2'].includes(tabs[componentInd].component)"
                style="cursor: pointer"
                @click="refreshData"
              />
            </div>

          </v-col>
        </v-row>
      </v-col>
    </v-container>
    <div v-else class="loading d-flex justify-center px-2 py-2 align-center">
      <v-progress-circular
        indeterminate
        color="#008C89"
      ></v-progress-circular>
    </div>
    <add-visit v-if="dialogs.addVisit.isOpen || dialogs.editVisit.isOpen" />
    <pending-evaluation v-if="dialogs.pendingEvaluation.isOpen" @updateStatus="handleStatusUpdate" />
    <complete-visit v-if="dialogs.completeVisit.isOpen" @complete="completeSurvey" />
    <days-supply-dialog v-if="dialogs.daysSupplyDialog.isOpen" @showPopup="showPopup"/>
    <quick-entry-form @updateSurvey="updateSurvey" v-if="dialogs.quickEntryDialog.isOpen"/>
    <result-group-supplement-totals v-if="dialogs.resultGroupSupplementTotals.isOpen"/>
    <previous-protocol @selectedPreviousProtocol="updateProtocol" v-if="dialogs.dialogShowPreviousProtocol.isOpen"/>
    <protocol @updateResult="updateResult" v-if="dialogs.dialogShowProtocol.isOpen"/>
    <modal-confirmation-delete-visit v-if="dialogs.modalConfirmationDeleteVisit.isOpen"/>
    <modal-reset-grid v-if="dialogs.modalResetGrid.isOpen" :onRecalcResults="onRecalcResults" :visitStatus="visit.status"/>
    <modal-confirmation-end-protocol v-if="dialogs.modalConfirmationEndProtocol.isOpen" @request="requestType"/>
    <modal-import-blood-report v-if="dialogs.modalImportBloodReport.isOpen" />
    <modal-survey-summary v-if="dialogs.modalSurveySummary.isOpen"/>
    <div class="custom-alert">
      <v-alert
        :color="alertColor"
        dismissible
        type="info"
        v-model="alertIsOpen"
      >
        <span style="font-size: 14px;">{{message || 'Visit was completed. Please check the available Reports'}}</span>
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import Tabs from '@/components/layouts/Tabs'
import Link from '@/components/elements/Link'
import results from '@/views/visits/tabs/results'
import results_2 from '@/views/visits/tabs/results_old'
import reports from '@/views/visits/tabs/reports'
import ResultsTotal from '@/views/visits/tabs/results-total'
import blood from '@/views/visits/tabs/blood'
// import blood_old from '@/views/visits/tabs/blood_old'
import receipt from '@/views/visits/tabs/receipt'
import survey from '@/views/visits/tabs/survey'
import BtnGroup from '@/components/layouts/btn-group'
import DosageControl from '@/components/elements/dosage-control'

import addVisit from '@/components/layouts/dialogs/add-visit'
import pendingEvaluation from '@/components/layouts/dialogs/pending-evaluation'
import Button from '@/components/elements/Button'
import SimpleInfoBlock from '@/components/elements/simple-info-block'
import Mapping from '@/mixins/Mapping'
import datepicker from '@/components/elements/datepicker'
import CompleteVisit from '@/components/layouts/dialogs/complete-visit'
import Image from '@/mixins/Image'
import Img from '@/components/elements/Img'
import DaysSupplyDialog from '@/components/layouts/dialogs/days-supply-dialog'
import checkbox from '@/components/elements/checkbox'
import Input from '@/components/elements/Input'
import ModalConfirmationDeleteVisit from '@/components/layouts/dialogs/modal-confirmation-delete-visit.vue'
import ModalResetGrid from '@/components/layouts/dialogs/modal-reset-grid.vue'
import ModalConfirmationEndProtocol from '@/components/layouts/dialogs/modal-confirmation-end-protocol.vue'
import ModalSurveySummary from '@/components/layouts/dialogs/modal-survey-summary.vue'
import ModalImportBloodReport from '@/components/layouts/dialogs/modal-import-blood-report.vue'
import status from '@/components/layouts/status'
import { trackEvent } from '@/utils/analytics'
import ChevronBlackIcon from '@/assets/icons/components/chevron-black-2.svg'
import InfoIcon from '@/assets/icons/components/info-icon.svg'
import PlusIcon from '@/assets/icons/components/plus-sm.svg'

import LabAboveIcon from '@/assets/icons/components/lab-above.svg'
import LabBelowIcon from '@/assets/icons/components/lab-below.svg'
import OptimalAboveIcon from '@/assets/icons/components/optimal-above.svg'
import OptimalBelowIcon from '@/assets/icons/components/optimal-below.svg'
import DateIcon from '@/assets/icons/components/date-2.svg'
import RefreshIcon from '@/assets/icons/components/refresh-icon.svg'

export default {
  name: 'view-visit',
  mixins: [Mapping, Image],
  components: {
    ModalImportBloodReport,
    ModalConfirmationEndProtocol,
    ModalConfirmationDeleteVisit,
    ModalResetGrid,
    ModalSurveySummary,
    Tabs,
    Link,
    results,
    results_2,
    reports,
    blood,
    receipt,
    survey,
    addVisit,
    pendingEvaluation,
    BtnGroup,
    Button,
    SimpleInfoBlock,
    ResultsTotal,
    datepicker,
    CompleteVisit,
    Img,
    DaysSupplyDialog,
    ChevronBlackIcon,
    InfoIcon,
    PlusIcon,
    LabAboveIcon,
    LabBelowIcon,
    OptimalAboveIcon,
    OptimalBelowIcon,
    DateIcon,
    RefreshIcon,
    QuickEntryForm: () => import('@/components/layouts/dialogs/quick-entry-form.vue'),
    ResultGroupSupplementTotals: () => import('@/components/layouts/dialogs/result-group-supplement-totals.vue'),
    Protocol: () => import('@/components/layouts/dialogs/protocol'),
    PreviousProtocol: () => import('@/components/layouts/dialogs/previous-protocol'),
    DosageControl,
    checkbox,
    Input,
    status
  },
  data: () => ({
    showDescriptionStatus: false,
    timerId: 0,
    componentInd: 0,
    tabIndex: 0,
    statusesToCheck: ['SurveySent', 'Survey Sent', 'Survey sent', 'SurveyDue', 'Survey Due', 'Survey due'],
    mockData: [
      {
        id: 1,
        title: 'Five main complaints',
        data: '- klfjkdls\n- fjdkfd'
      },
      {
        id: 2,
        title: 'Notes for Patient',
        data: '- klfjkdls\n- fjdkfd\n- fjdkfd'
      },
      {
        id: 3,
        title: 'Notes for Practitioner',
        data: '- klfjkdls\n- fjdkfd\n- fjdkfd\n- fjdkfd'
      }
    ],
    visitDate: null,
    alertColor: '#7ac1fb',
    alertIsOpen: false,
    message: null,
    timeLinesData: [
      {
        name: 'Survey Sent',
        date: '04/18/2022',
        colorText: '#A0AEC0',
        bgColor: '#EDF2F7',
        isCurrentStatus: false
      },
      {
        name: 'Wait Patient for Submit',
        date: null,
        colorText: '#008C89',
        bgColor: '#79d6d4',
        isCurrentStatus: true
      },
      {
        name: 'Approve',
        date: null,
        colorText: '#FFFFFF',
        bgColor: '#008C89',
        isCurrentStatus: false
      },
      {
        name: 'Complete1',
        date: null,
        colorText: '#FFFFFF',
        bgColor: '#008C89',
        isCurrentStatus: false
      },
      {
        name: 'In Protocol',
        date: null,
        colorText: '#A0AEC0',
        bgColor: '#EDF2F7',
        isCurrentStatus: false
      },
      {
        name: 'Complete',
        date: null,
        colorText: '#A0AEC0',
        bgColor: '#EDF2F7',
        isCurrentStatus: false
      }
    ],
    priceModel: {
      $id: '59',
      args: '',
      code: 'StandardSLP',
      name: 'Standard SLP'
    },
    // calcMethod: {
    //   $id: '69',
    //   args: '',
    //   code: 'SP',
    //   names: 'Specific Question-Based Support - Standard Process*',
    // },
    isOpenPriceModel: false,
    hidePricingOnReceipt: false,
    isUpdateResults: false,
    isUpdateSurvey: false,
    isUpdateDaysSupply: false,
    isUpdateVisit: false,
    nowDate: new Date(new Date().setDate(new Date().getDate())).toISOString().slice(0, 10),
    bloodIsFasting: false,
    isDropdownVisible: false,
    isShowMinDate: process.env.VUE_APP_PRODUCTION_MODE
  }),
  methods: {
    ...mapActions('visits', ['getVisit', 'updateReschedule', 'updateNotes', 'visitProcess', 'endProtocol', 'concludeDialog']),
    ...mapActions('results', ['getSupplements', 'recalcResults', 'refreshResults', 'getNotes', 'getResults']),
    ...mapActions('surveys', ['updateStatus', 'finishSurvey', 'approveSurvey', 'getSurveyGroups', 'getDetailsTestComplaints']),
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    ...mapMutations('surveys', ['UPDATE_FIELD_DATA']),
    ...mapActions('patients', ['getPatient']),
    ...mapActions('receipts', ['getReceipts', 'createReceiptPreview']),
    ...mapActions('blood', ['updateBloodTestDate']),

    openImportModal() {
      this.TOGGLE_DIALOG({
        name: 'modalImportBloodReport',
        isOpen: true,
        title: 'Import Blood Report',
        data: {
          patient: this.visit.patient,
          visitId: this.visit.id,
          onSuccess: async () => {
            const tabComponent = this.$refs.currentTabComponent

            if (tabComponent && typeof tabComponent.initData === 'function') {
              await tabComponent.initData()
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
            await this.loadData(this.visit.id);
            return true;
          }
        }
      })
    },

    async processVisit () {
      trackEvent(this, 'visit_action', 'Visit', 'Process Visit Clicked',
        { visitId: this.visit.id }
      )

      if (this.getDataAndStylesMainVisitControl[this.visit.status]?.buttonTitle === 'End Protocol Early / Adjust Protocol') {
        const res = await this.endProtocol(this.visit.id)

        if (res.show) {
          this.TOGGLE_DIALOG(
            {
              name: 'modalConfirmationEndProtocol',
              isOpen: true,
              title: 'End Protocol Early / Adjust Protocol',
              data: { ...res, patient: this.visit.patient }
            })
        }
        else {
          await this.processVisitData()
        }
      }
      else if (this.getVisitControlConfig(this.visit)?.buttonTitle === 'Conclude Evaluation') {
        const res = await this.concludeDialog(this.visit.id)

        if (res.show) {
          this.TOGGLE_DIALOG(
            {
              name: 'modalConfirmationEndProtocol',
              isOpen: true,
              title: 'Track Protocol / End Evaluation',
              data: { ...res, patient: this.visit.patient, supplyDays: this.visit.supplyDays }
            })
        }
        else {
          await this.processVisitData()
        }
      } else {
        await this.processVisitData()
      }
    },
    async processVisitData() {
      const data = {
        doctorId: this.visit.doctor.id,
        visitId: this.visit.id,
        visitStatus: this.getDataAndStylesMainVisitControl[this.visit.status].statusInPayloadRequest,
        addVisit: false,
        date: this.$moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
        notes: this.visit.notes
      }
      const res = await this.visitProcess({ data })

      if (res.res === true) {
        trackEvent(this,'visit_processed', 'Visit', `Visit processed with status ${data.visitStatus}`, {
          visitId: this.visit.id
        })

        const { params } = this.$route
        this.loadData(params?.id)
        switch (data.visitStatus) {
          case 'InProtocol':
            this.changeTab({ title: 'receipt', component: 'receipt' })
            break
          case 'Reviewed':
            this.changeTab({ title: 'results', component: 'results' })
            // this.changeTab({ title: 'results', component: 'results_2' })
            break
        }
      } else {
        trackEvent(this,'visit_process_failed', 'Visit', 'Visit Process Failed', {
          visitId: this.visit.id
        })
      }
    },
    async requestType (formData) {
      const data = {
        doctorId: this.visit.doctor.id,
        visitId: this.visit.id,
        visitStatus: (formData.activeProtocol === 'adjust-protocol') ? 'InProgress' : (formData.activeProtocol === 'protocol-start' ? 'InProtocol' : 'Completed'),
        addVisit: formData.addNextEvaluation,
        nonSurvey: formData.nonSurvey ? true : false,
        date: this.$moment(formData.evaluationDate).format('YYYY-MM-DDTHH:mm:ss'),
        processDate: this.$moment(formData.consultDate).format('YYYY-MM-DDTHH:mm:ss'),
        notes: this.visit.notes
      }
      const res = await this.visitProcess({ data })
      this.TOGGLE_DIALOG({ name: 'modalConfirmationEndProtocol', isOpen: false, root: true })
      if (res.res === true) {
        const { params } = this.$route

        if (formData.activeProtocol === 'protocol-start') {
          if (formData.addNextEvaluation && formData.survey) {
            trackEvent(this, 'conclude_eval_start_protocol', 'Evaluation', 'Start Protocol with Add Next Evaluation Date - Survey Evaluation');
          } else if (formData.addNextEvaluation && formData.nonSurvey) {
            trackEvent(this, 'conclude_eval_start_protocol', 'Evaluation', 'Start Protocol with Add Next Evaluation Date - Non-Survey Evaluation');
          } else {
            trackEvent(this, 'conclude_eval_start_protocol', 'Evaluation', 'Start Protocol');
          }
        }

        if (formData.activeProtocol === 'protocol-end-evaluation') {
          if (formData.addNextEvaluation && formData.survey) {
            trackEvent(this, 'conclude_eval_end_protocol', 'Evaluation', 'End Protocol with Add Next Evaluation Date - Survey Evaluation');
          } else if (formData.addNextEvaluation && formData.nonSurvey) {
            trackEvent(this, 'conclude_eval_end_protocol', 'Evaluation', 'End Protocol with Add Next Evaluation Date - Non-Survey Evaluation');
          } else {
            trackEvent(this, 'conclude_eval_end_protocol', 'Evaluation', 'End Protocol');
          }
        }

        this.loadData(params?.id)

        switch (formData.activeProtocol) {
          case 'protocol-start':
            this.loadData(params?.id);
            break;

          case 'protocol-end-evaluation':
            if (data.addVisit && res.data.status !== 'Pending') {
              this.$router.replace({ params: { id: res.data.id }})
              window.location.reload()
            }
            break;

          case 'end-protocol':
            if (data.addVisit && res.data.status !== 'Pending') {
              this.$router.replace({ params: { id: res.data.id }})
              window.location.reload()
            }
            break;

          case 'adjust-protocol':
            this.$router.replace({ params: { id: res.data.id }})
            window.location.reload()
        }

        switch (data.visitStatus) {
          case 'InProtocol':
            this.changeTab({ title: 'receipt', component: 'receipt' })
            break
          case 'Reviewed':
            this.changeTab({ title: 'results', component: 'results' })
            // this.changeTab({ title: 'results', component: 'results_2' })
            break
        }
      }
    },
    onRecalcResults (visitStatus) {
      if(!['InProtocol', 'Completed', 'Closed', 'NeedProduct', 'ProtocolEnding'].includes(visitStatus)) {
        const { id } = this.$route.params
        this.recalcResults({ id })
        this.$emit('changeTab', { title: 'results', component: 'results' })
        // this.$emit('changeTab', { title: 'results', component: 'results_2' })
      }
    },
    openPatientDetails () {
      this.$router.push({ name: 'View patient', params: { id: this.visit.patient.id }, query: this.$route.query })
    },
    openResult () {
      trackEvent(this, 'customize', 'Results', 'Supplement')

      if (!this.visit.finishedOn || (!['InProtocol', 'NeedProduct', 'Completed', 'ProtocolEnding'].includes(this.visit.status))) {
        this.TOGGLE_DIALOG({ name: 'addResult', isOpen: true, title: 'Add supplement' })
      }
    },
    openShowPreviousProtocol () {
      trackEvent(this, 'customize', 'Results', 'Previous Protocol')

      if (!this.visit.finishedOn || (!['InProtocol', 'NeedProduct', 'Completed', 'ProtocolEnding'].includes(this.visit.status))) {
        this.TOGGLE_DIALOG({ name: 'dialogShowPreviousProtocol', isOpen: true, title: 'Select protocol' })
      }
    },
    openShowProtocol () {
      trackEvent(this, 'customize', 'Results', 'Protocol')

      if (!this.visit.finishedOn || (!['InProtocol', 'NeedProduct', 'Completed', 'ProtocolEnding'].includes(this.visit.status))) {
        this.TOGGLE_DIALOG({ name: 'dialogShowProtocol', isOpen: true, title: 'Select protocol' })
      }
    },
    openModalResetGrid() {
      this.TOGGLE_DIALOG(
        {
          name: 'modalResetGrid',
          isOpen: true,
          title: 'Reset Grid',
          visitId: this.visit.id,
          data: '<p>You are about to remove all customizations you\'ve made to the results grid (added supplements or protocols, supplement notes, dosing, quantities, etc). Patient and Evaluation notes will be preserved.</p>'
        })
    },
    openModalConfirmationDeleteVisit () {
      this.TOGGLE_DIALOG(
        {
          name: 'modalConfirmationDeleteVisit',
          isOpen: true,
          title: 'Delete Evaluation',
          visitId: this.visit.id,
          data: '<p>Are you sure you want to delete an Evaluation and all of its associated data?</p>'
        })
    },
    openDatePicker() {
      this.$refs.datepicker.menu = true
    },
    async openSurveyDialog () {
      this.TOGGLE_DIALOG(
        {
          name: 'modalSurveySummary',
          surveyId: this.visit.surveyId,
          isOpen: true
        })

      trackEvent(this, 'open_survey_summary', 'Survey', 'Open Survey Summary Modal', {
        surveyId: this.visit.surveyId
      });
    },
    updateOrderMethod (val) {
      this.priceModel = val
    },
    updateSurvey (val) {
      this.isUpdateSurvey = val
    },
    updateSurveySummary (val) {
      if (val >= 0) {
        this.visit.surveyScore = val
      }
    },
    updateResult (val, systemParam) {
      if (systemParam) {
        this.isUpdateResults = val
        this.alertIsOpen = true
        if (systemParam.data) {
          this.alertColor = '#7ac1fb'
          this.message = `${systemParam.data} was selected`
        }
        if (systemParam.error) {
          this.alertColor = '#CF4655'
          this.message = `${systemParam.error}`
        }
        const self = this
        setTimeout(function () {
          self.alertIsOpen = false
        }, 3000)
      }
    },
    updateProtocol (val, systemParam) {
      if (systemParam) {
        this.alertIsOpen = true

        if (systemParam.data) {
          this.alertColor = '#7ac1fb'
          this.message = `${systemParam.data} was added successfully`
        }
        if (systemParam.error) {
          this.alertColor = '#CF4655'
          this.message = `${systemParam.error}`
        }
        const self = this
        setTimeout(function () {
          self.alertIsOpen = false
        }, 3000)
      }
    },
    loadData (id) {
      return this.getVisit({id}).then(res => {
        // this.calcMethod = this.calcMethodList.find(item => item.code === this.visit.calcMethodTypeCode)
        this.priceModel = this.patientOrderMethods.find(item => item.code === this.visit?.receiptOrderTypeCode)
        if (res.status && res.status === 400) {
          this.alertIsOpen = true
          this.alertColor = '#CF4655'
          this.message = `${res.data.message}`
          const self = this
          setTimeout(function () {
            self.alertIsOpen = false
            self.$router.push({name: 'Patients'})
          }, 3000)
        } else {
          this.getNotes(id)
          this.$route.meta.headerTitle = `Visit details - ${this.$moment(this.visit.date).format('MM/DD/YYYY')} - ${this.visit.patient.firstName} ${this.visit.patient.lsatName}`
          this.visitDate = this.visit.date
          document.title = `Visit ${this.$moment(this.visitDate).format('MM/DD')} - Maestro Practitioner Portal`
          this.getPatient({ id: this.visit.patient.id })
          if (this.visit.visitStatus === 'Pending') {
            this.TOGGLE_DIALOG({
              name: 'pendingEvaluation',
              pendingDays: this.visit.pendingDays,
              visitId: this.visit.id,
              isOpen: true,
            })
          }
        }
      })
    },
    tab ($event) {
      this.componentInd = $event
      this.tabIndex = $event
    },
    edit ($event) {
      $event.preventDefault()
      const { id } = this.visit.patient
      if (id) {
        this.TOGGLE_DIALOG({ id: id, name: 'editVisit', title: 'Reschedule Evalutation', isOpen: true })
      }
    },
    updateNote ({ notes, data }) {
      const prepareData = {
        apiUrl: data.apiUrl,
        field: data.field,
        visitId: this.visit.id
      }
      if (data.apiUrl === 'survey/complaints') {
        prepareData.dataForSend = {
          complaints: notes.split('\n')
        }
      } else {
        prepareData.dataForSend = {
          notes: notes
        }
      }
      this.updateNotes(prepareData)
    },
    async completeSurvey (data) {
      const res = await this.finishSurvey({ visitId: this.$route.params.id, surveyId: this.visit.surveyId, ...data })
      if (res) {
        this.TOGGLE_DIALOG({ name: 'completeVisit', isOpen: false })
        this.loadData(this.$route.params.id)
        this.alertIsOpen = true
        const self = this
        setTimeout(function () {
          self.tab(2)
        }, 1300)
      }
    },
    async updateVisitDate (val) {
      this.getSurveyGroups({ surveyID: this.visit.surveyId, additionalParam: '?includeAllGroups=true' })
      if (val) {
        trackEvent(this, 'change_evaluation_date', 'Evaluation', 'Change Evaluation Date', {
          date: val,
          doctorId: this.visit.doctor.id,
          patientId: this.visit.patient.id
        })

        this.visitDate = val
        document.title = `Visit ${this.$moment(this.visitDate).format('MM/DD')} - Maestro Practitioner Portal`
        const data = {
          id: this.$route.params.id,
          data: {
            id: this.$route.params.id,
            date: val,
            doctorId: this.visit.doctor.id,
            patientId: this.visit.patient.id
          }
        }
        const res = await this.updateReschedule(data)
        if (res && res.status) {
          trackEvent(this, 'reschedule_visit', 'Visit', 'Visit Rescheduled', {
            value: this.$route.params.id
          })

          this.handleStatusUpdate(res.status);
        }
        this.UPDATE_FIELD_DATA({ key: 'dueDate', value: res.date })
      }
    },
    updateBloodDate(val) {
      this.updateBloodTestDate({ id: this.visit.bloodTestId, params: { bloodTestId: this.visit.bloodTestId, bloodTestDate: val } })
      trackEvent(this, 'date_change', 'Blood', `Blood Draw Date selected: ${val}`)
    },
    changeTab (tab) {
      this.tabIndex = this.tabs.findIndex(item => item.component === tab.component)
      this.tab(this.tabIndex)
    },
    async showPopup () {
      this.alertIsOpen = true
      this.message = 'Days Supply was changed!'
      const self = this
      setTimeout(function () {
        self.alertIsOpen = false
      }, 1300)
      this.TOGGLE_DIALOG({ name: 'daysSupplyDialog', isOpen: false })
      this.isUpdateDaysSupply = true
    },
    openChangeDaysSupplModal () {
      if (this.tabs[this.componentInd].component === 'results' || this.tabs[this.componentInd].component === 'results_2') {
        if (!this.visit.finishedOn && this.visit.status !== 'Completed' && this.visit.status !== 'InProtocol' && this.visit.status !== 'ProtocolEnding') {
          this.TOGGLE_DIALOG({ name: 'daysSupplyDialog', title: 'Change Evaluation Supply Days', isOpen: true })
        }
      } else {
        this.TOGGLE_DIALOG({ name: 'daysSupplyDialog', title: 'Change Evaluation Supply Days', isOpen: true })
      }
    },
    refreshData () {
      if (this.tabs[this.componentInd].component === 'results' || this.tabs[this.componentInd].component === 'results_2') {
        if (!this.visit.finishedOn || (!['InProtocol', 'NeedProduct', 'Completed', 'ProtocolEnding'].includes(this.visit.status))) {
          switch (this.tabs[this.componentInd].component) {
            case 'survey':
              this.getSurveyGroups({ surveyID: this.visit.surveyId, additionalParam: '?includeAllGroups=true' })
              this.getDetailsTestComplaints({ surveyID: this.visit.surveyId })
              break
            case 'results':
              this.refreshResults({ id: this.visit.resultId })
              break
            case 'results_2':
              this.refreshResults({ id: this.visit.resultId })
              break
            case 'reports':
              break
          }
        }
      } else {
        switch (this.tabs[this.componentInd].component) {
          case 'survey':
            this.getSurveyGroups({ surveyID: this.visit.surveyId, additionalParam: '?includeAllGroups=true' })
            this.getDetailsTestComplaints({ surveyID: this.visit.surveyId })
            break
          case 'results':
            this.refreshResults({ id: this.visit.resultId })
            break
          case 'results_2':
            this.refreshResults({ id: this.visit.resultId })
            break
          case 'reports':
            break
        }
      }
      this.getNotes(this.$route.params.id)
    },
    openGroupSupplementTotals (type) {
      this.TOGGLE_DIALOG({ name: 'resultGroupSupplementTotals', title: `${type} Totals`, isOpen: true, data: { type } })
    },
    showStatusDescription () {
      this.showDescriptionStatus = !this.showDescriptionStatus
      clearTimeout(this.timerId)
      if (this.showDescriptionStatus) {
        const self = this
        this.$nextTick(() => {
          self.timerId = setTimeout(function () {
            self.showDescriptionStatus = false
          }, 3000)
        })
      }
    },
    async updatePriceModel ({ data }, oldValue) {
      const { id } = this.$route.params
      this.priceModel = this.patientOrderMethods.find(item => item.code === data.code)
      const orderMethod = this.priceModel.code

      if (oldValue !== data.name) {
        trackEvent(this, 'change_price_model', 'Evaluation', `Changed Price Model to ${data.code}`)

        const currentTabComponent = this.tabs[this.componentInd].component

        if (currentTabComponent === 'results') {
          await this.getResults({ id, orderMethod })
          // this.isUpdateVisit = true
        } else {
          const resultVisit = await this.getVisit({id, orderMethod, calcMethod: null})
          if (resultVisit) {
            this.isUpdateVisit = true
          }
        }
      }
    },
    openConfirmationDialog () {
      this.TOGGLE_DIALOG({
        visitId: this.visit.id,
        name: 'confirm',
        isOpen: true,
        action: 'visits/markForReview',
        whose: 'confirmationMoveEvaluation',
        title: 'Confirm Need Review Status',
        description: 'Please confirm evaluation status change to Need Review'
      })
    },
    handleStatusUpdate(newStatus) {
      trackEvent(this,'begin_evaluation', 'Visit', 'User began evaluation', {
        status: newStatus
      })
      this.visit.status = newStatus
    },
    formatHeight(height) {
      if (!height) return ''

      const feet = Math.floor(height)
      const inchesStr = height.toFixed(2).split('.')[1]
      const inches = parseInt(inchesStr, 10)
      return `${feet}' ${inches}"`
    },
    getButtonTitleWithCondition(visit) {
      const statusConfig = this.getDataAndStylesMainVisitControl[visit.status]

      if (this.statusesToCheck.includes(visit.status)) {
        if (!visit.patient.registerPortal || visit.nonSurvey) {
          return 'Conclude Evaluation'
        } else {
          return 'Approve Survey'
        }
      }

      return statusConfig?.buttonTitle
    },
    getVisitControlConfig(visit) {
      const overrideToInProgress =
        this.statusesToCheck.includes(visit.status) &&
        (!visit.patient.registerPortal || visit.nonSurvey)

      return overrideToInProgress
        ? this.getDataAndStylesMainVisitControl['InProgress']
        : this.getDataAndStylesMainVisitControl[visit.status]
    },

  },
  destroyed () {
    this.tab(0)
  },
  mounted () {
    const { params } = this.$route
    sessionStorage.setItem('selectedPage', this.$route.path)
    if (params?.id) {
      this.loadData(params?.id)
      this.$store.state.visits.visit = null // temp code
    }
  },
  created () {
    const { query } = this.$route
    if (query?.tabIndex) {
      this.tabIndex = query.tabIndex
    }
  },
  computed: {
    ...mapState({
      visit: state => state.visits?.visit,
      result: state => state.results?.results,
      patient: state => state.patients.patient,
      status: state => (state.surveys?.status?.visit?.status) ? state.surveys?.status?.visit?.status : state.surveys?.status?.status,
      subscriptionFeatures: state => state.subscription,
      patientOrderMethods: state => state.visits?.visit?.orderMethods?.$values.map(item => {
        return {
          ...item,
          text: item.name,
          value: item.code,
          id: item.$id
        }
      }),
      bloodData: state => state.blood.bloodData
    }),
    ...mapState('receipts', {
      receiptPreview (state) {
        return state?.receiptsPreview?.record
      },
    }),
    tabs () {
      const allTabs = [
        { title: 'survey', component: 'survey', count: this.visit.totalSurveyAnsweredQuestions },
        { title: 'blood', component: 'blood', count: this.visit.totalBloodEnteredValues },
        // { title: 'blood_old', component: 'blood_old', count: this.visit.totalBloodEnteredValues },
        { title: 'results', component: 'results', count: this.selectedSupplementsCount },
        // { title: 'results_2', component: 'results_2', count: this.visit.totalSelectedResultSupplements },
        { title: 'reports', component: 'reports' },
        { title: 'invoices', component: 'receipt', count: this.visit.totalInvoices }
      ]
      if (!this.subscriptionFeatures.features.$values.includes('Blood')) { // for Blood
        allTabs.splice(1, 1)
      }
      if (this.subscriptionFeatures.productName.includes('Reports Only')) { // for receipt
        allTabs.splice(3, 1)
      }
      if (!this.subscriptionFeatures.features.$values.includes('Survey')) { // for survey
        allTabs.splice(0, 1)
      }
      return allTabs
    },
    dialogs () {
      return this.$store.state.dialogs
    },
    surveyReadOnly () {
      return this.$store.state.surveys.surveyGroups?.readonly
    },
    surveyGroups () {
      return this.$store.state.surveys.surveyGroups?.groups?.$values
    },
    isVisitDisabled() {
      return (
        (this.visit && this.visit.finishedOn !== null) ||
        ['InProtocol', 'NeedProduct', 'Completed', 'ProtocolEnding'].includes(this.visit.status)
      )
    },
    selectedSupplementsCount () {
      // results are reloaded after every add/remove, the visit count only when the visit is loaded
      const record = this.result?.record
      if (record && record.visitId === this.visit?.id && typeof record.totalSelectedResultSupplements === 'number') {
        return record.totalSelectedResultSupplements
      }
      return this.visit?.totalSelectedResultSupplements || 0
    },
    isProcessDisabled () {
      // same title as the button shows - it can be 'Conclude Evaluation' for Survey Sent/Due statuses too
      const btnTitle = this.getButtonTitleWithCondition(this.visit)?.toLowerCase() || ''
      return btnTitle === 'conclude evaluation' && this.selectedSupplementsCount === 0
    },
    hasDocumentsAccess() {
      return (this.subscriptionFeatures?.features?.$values || [])
        .map(f => f.toLowerCase())
        .includes('documents')
    }
  },
  watch: {
    visit (val) {
      if (val) {
        this.$route.meta.headerTitle = `Visit details - ${this.$moment(val.date).format('MM/DD/YYYY')} - ${val.patient.firstName} ${val.patient.lastName}`
        this.visitDate = val.date
        document.title = `Visit ${this.$moment(this.visitDate).format('MM/DD')} - Maestro Practitioner Portal`
      }

    },
  },
  beforeDestroy () {
    localStorage.removeItem('groupDescription')
  }
}
</script>

<style lang="scss" scoped>
  .view-visit {
    .btn-white {
      ::v-deep .v-btn {
        color: #008C89;
        font-size: 13px;
        font-weight: 600;
        line-height: 1;
        letter-spacing: 0;
        border-radius: 8px;
        background-color: transparent;
        border: 1px solid #008C89;
        padding: 12px 20px;
      }
    }

    .disabled {
      pointer-events: none;
    }

    ::v-deep .v-card {
      .v-card__text {
        padding: 0!important;
      }
    }
    ::v-deep .tabs {
      .v-window {
        padding: 1px;
      }
    }
    background: #F7FAFC;
    .btn-cost {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-left: 3px;
      font-weight: 600;
      font-size: 14px;
      color: #425466;
      .days-60 {
        color: $dark-green;
        text-decoration: underline;
      }
      .days-60.disable-days {
        color: red;
      }
    }
    ::v-deep .tabs .v-tabs .v-item-group {
      background: transparent!important;
    }
    ::v-deep .tabs .v-tabs-items {
      background: transparent!important;
    }
    ::v-deep .tabs .v-window .v-window-item .v-card {
      border-radius: 16px!important;
    }
    ::v-deep .v-input {
      &__slot {
        margin: 0;
      }
      .v-messages {
        display: none;
      }
    }
    .v-icon {
      cursor: pointer;
    }
    .wrap-container {
      column-gap: 0.5rem;
    }
    .loading {
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .gray-btn-color-text {
      color: #A0AEC0;
    }
    .price-model-select {
      column-gap: 10px;

      ::v-deep .v-btn {
        height: 36px;
        width: 126px;
        padding: 9px 10px;
        box-shadow: none;

        &.v-btn--disabled {
          background-color: transparent !important;
        }

        &:first-child {
          width: 153px;
        }

        &__content {
          display: flex;
          align-items: center;
          column-gap: 10px;
        }

        &:hover,
        &:focus {
          background-color: transparent !important;

          &::before {
            opacity: 0 !important;
          }
        }

        span {
          font-weight: 600;
          letter-spacing: 0;
        }
      }

      .select {
        ::v-deep .v-input {
          height: 36px!important;
          width: 185px!important;
        }
      }

    }
    .input-setting, .checkbox-setting {
      ::v-deep .v-input {
        width: 42px!important;
        &__control {
          .v-text-field__details {
            display: none!important;
          }
          .v-input__slot {
            padding: 0 1px!important;
          }
        }
      }
    }
    .checkbox-setting .checkbox {
      width: 25px;
    }

    &__header-status{
      .status {
        padding: 3px 8px;
      }

      .status-title {
        color: #1A202C;
        font-weight: 600;
        font-size: 20px;
        line-height: 1;
        padding-right: 14px;
      }
    }
    &__header {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      column-gap: 0.5rem;
      &-title {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        color: #27272E;
        padding-left: 10px;
        margin-top: -20px;
      }
      .time-line-wrap {
        position: relative;
        height: 85px;
        padding-top: 14px;
        margin-top: -14px;
        display: flex;
        column-gap: 1rem;
        max-width: calc(100% - 90px);
        width: 87%;
        overflow-x: auto;
        overflow-y: hidden;
        .status-btn {
          border-radius: 10px;
          position: relative;
          width: 140px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: center;
          cursor: pointer;
          text-align: center;
          padding: 5px 2px;
          font-family: 'Poppins';
          .status-name {
            font-weight: 500;
            font-size: 12px;
            width: 100%;
          }
          .status-date {
            font-size: 10px;
          }
          .current-status.triangle {
            position: absolute;
            transform: rotate(225deg);
            top: -15px;
            left: 50%;
            box-sizing: border-box;
            width: 10px;
            height: 10px;
            border-top-left-radius: 1px;
            border-right: solid 5px transparent;
            border-bottom: solid 5px transparent;
            border-left: solid 5px $dark-green;
            border-top: solid 5px $dark-green;
          }
          .triangle {
            position: absolute;
            right: -8px;
            transform: rotate(135deg);
            box-sizing: border-box;
            width: 20px;
            height: 20px;
            border-top-left-radius: 5px;
            border-right: solid 10px transparent;
            border-bottom: solid 10px transparent;
          }
          .triangle-left {
            position: absolute;
            left: -20px;
            width: 0;
            height: 0;
            border-top: 31px solid #f7fafc;
            border-right: 31px solid transparent;
            transform: rotate(135deg);
          }
        }
        .light-grey-bg {
          background-color: #EDF2F7;
        }
        .light-grey-text {
          color: #A0AEC0;
        }
        .green-light-bg {
          background-color: #79d6d4;
        }
        .green-text {
          color: $dark-green;
        }
        .white-text {
          color: #FFFFFF;
        }
        .green-bg {
          background-color: $dark-green;
        }
        .border-left-light-grey {
          border-left: solid 10px #EDF2F7;
        }
        .border-left-light-green {
          border-left: solid 10px #79d6d4;
        }
        .border-left-green {
          border-left: solid 10px $dark-green;
        }
        .border-top-light-grey {
          border-top: solid 10px #EDF2F7;
        }
        .border-top-light-green {
          border-top: solid 10px #79d6d4;
        }
        .border-top-green {
          border-top: solid 10px $dark-green;
        }
      }
      ::-webkit-scrollbar:horizontal {
        height: 15px;
      }
      ::-webkit-scrollbar-track:horizontal {
        background: #F7FAFC;
      }
      ::-webkit-scrollbar-thumb:horizontal {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #d1eadd;
      }
    }

    .visit-card-main-data {
      height: 100%;
      padding: 10px 14px 12px !important;
      border-radius: 16px !important;
      box-shadow: 0px 10px 20px 0px #7180960F;

      .visit-controls {
        .icon-more {
          min-width: 38px;
          width: 38px;
          height: 38px;
          border-radius: 8px;
          padding: 6px;
          background-color: transparent;
        }
      }

      .main-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        column-gap: 0.3rem;
        row-gap: 2rem;

        .full-name-avatar {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          column-gap: 0.5rem;
          &__avatar {
            cursor: pointer;
          }
          &__full-name {
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            color: #1A202C;
            cursor: pointer;
          }
        }
        .last-visit {
          display: flex;
          align-items: center;
          column-gap: 9px;

          & > span {
            color: #718096;
            font-size: 14px;
            font-weight: 400;
          }

          &__title {
            font-style: normal;
            font-size: 16px;
            color: #1A202C;
          }
          &__date {
            .btn-date {
              position: relative;
              display: flex;
              align-items: center;
              column-gap: 16px;
              border-radius: 8px;
              background-color: #EDF2F7;
              padding: 10px 48px 10px 16px;

              &__text {
                color: #1A202C;
                font-weight: 500;
                font-size: 14px;
              }

              .datepicker {
                ::v-deep .v-input {
                  input {
                    user-select: none;
                    cursor: pointer;
                  }
                }
              }
            }
            .btn-date.disabled {
              cursor: unset;
              pointer-events: none;

              .btn-date__text {
                color: #718096;
              }
            }
          }
        }
        .patient-parameters {
          display: flex;
          flex-wrap: wrap;
          align-items: baseline;
          column-gap: 6px;
          &__title {
            font-weight: 400;
            font-size: 12px;
            color: #718096;
            padding-right: 6px;
          }
          &__value {
            font-weight: 400;
            font-size: 14px;
            color: #1A202C;
          }
          &__block {
            .separator {
              padding-right: 6px;
            }
          }
        }
        .visit-controls {
          justify-content: end;
          width: 310px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          column-gap: 0.2rem;
        }
      }
    }
    .visit-controls__supply-days {
      display: flex;
      align-items: center;
      border-radius: 8px;
      height: 36px;
      width: 126px;
      font-weight: 600;
      font-size: 14px;
      padding: 9px 10px;
      cursor: pointer;

      &.disabled {
        background-color: transparent !important;
      }

      .days-60 {
        color: #1A202C;
        font-size: 14px;
        letter-spacing: 0;
      }

      //.days-60.disable-days {
      //  color: red;
      //}

      &:hover {
        background-color: transparent !important;
      }
    }

    .visit-controls__main-button {
      ::v-deep .v-btn {
        &.v-btn--disabled {
          color: #ffffff !important;
          background-color: #008C89 !important;
          cursor: not-allowed !important;
        }
      }
    }
    .visit-controls__main-button.in-progress {}
    .visit-controls__main-button.survey-sent {
      ::v-deep .v-btn {
        background-color: #668BFF;
      }
    }
    .visit-controls__main-button.survey-due {
      ::v-deep .v-btn {
        background-color: #F7936F;
      }
    }
    .visit-controls__main-button.need-review {
      ::v-deep .v-btn {
        background-color: #668BFF;
      }
    }
    .visit-controls__main-button.reviewed {}
    .visit-controls__main-button.in-protocol {
      ::v-deep .v-btn {
        background-color: #668BFF;
      }
    }
    .visit-controls__main-button.protocol-ending {
      ::v-deep .v-btn {
        background-color: #FFE9E2;
      }
    }
    .visit-controls__main-button.closed {
      display: none;
    }

    .visit-info {
      &__closed {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 44px;
        p {
          color: #718096;
          font-size: 16px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 1.62;
          margin: 0;
        }
      }
    }

    .custom-alert {
      max-width: 300px;
      position: fixed;
      top: 10px;
      right: 20px;
      z-index: 100;
    }

    .wrapper-blood-control {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;

      ::v-deep .v-input {
        margin-top: 0px!important;
        padding-top: 0px!important;
        align-items: center!important;
      }
      &__block {
        display: flex;
        column-gap: 10px;

        .legend {
          width: auto;
          padding: 4px 12px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          column-gap: 7px;
        }
        .blood-lab {
          background-color: rgba(255, 211, 208, 0.7);
        }
        .blood-optimal {
          background-color: #FFEDBF;
        }
        .legend-text {
          display: flex;
          align-items: center;
          column-gap: 1px;
          font-weight: 400;
          font-size: 10px;
          color: #425466;

          &.bold {
            font-weight: 600;
          }
        }

        ::v-deep .v-input {
          &.v-input--is-label-active {
            .v-input--selection-controls__input .v-icon {
              color: #008C89 !important;
              caret-color: #008C89 !important;
            }
          }

          .v-input--selection-controls__input .v-icon {
            color: #C9CED6 !important;
          }

          .v-input__control {
            label {
              font-weight: 500;
              font-size: 14px;
              color: #0A1F44;
            }
          }
        }

        .btn-white {
          margin-left: 30px;

          span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            background-color: rgba(0, 140, 137, 0.1);
            border-radius: 50%;
            font-weight: 600;
            font-size: 12px;
            color: #008C89;
            margin-left: 10px;
          }
        }

      }

      .blood-draw-date {
        display: flex;
        column-gap: 10px;
        align-items: center;
        &__label {
          color: #425466;
          font-weight: 500;
          font-size: 13px;
        }
        &__date {
          position: relative;
          display: flex;
          align-items: center;
          column-gap: 16px;
          background-color: #EDF2F7;
          border-radius: 8px;
          padding: 8px 48px 7px 16px;
          .datepicker {
            ::v-deep .v-input {
              input {
                user-select: none;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .buttons-wrapper {
      display: flex;

      ::v-deep .v-menu {
        .v-menu__content {
          width: 260px;
          box-shadow: 0px 10px 20px 0px #7180960F;
          border-radius: 8px;
        }
      }
    }

    .btn-protocol {
      margin-left: 10px;
    }

    .btn-supplement,
    .btn-protocol {
      ::v-deep .v-btn {
        background-color: #E4ECF7;
        border-radius: 6px;
        padding: 12px 20px;

        .title-btn {
          color: #1A202C;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0;
        }
      }
    }
    .btn-survey {
      ::v-deep .v-btn {
        background-color: rgba(208, 220, 255, 0.5);
        border-radius: 8px;
        padding: 9px 22px 9px 15px;

        .v-btn__content {
          width: 100%;
          height: 100%;
          justify-content: space-between;
        }

        .text {
          color: #1A202C;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0;
        }

        .amount {
          color: #1A202C;
          font-size: 20px;
          font-weight: 700;
          letter-spacing: 0;
        }
      }
    }
  }

  .more-menu {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    border-radius: 8px;
    box-shadow: 0px 1px 3px 0px #3232471A,
    0px 0px 1px 0px #0C1A4B33;
    padding: 14px 12px;

    & > div {
      display: flex;
      align-items: center;
      column-gap: 12px;
      padding: 10px 10px 8px;
      cursor: pointer;
    }
  }

  ::v-deep .v-tabs-slider-wrapper {
    height: 1px !important;

    .v-tabs-slider {
      color: #4FAA6E;
      border-radius: 20px;
    }
  }

  ::v-deep .v-btn.btn-customize-dropdown {
    box-shadow: none;
    background-color: #E4ECF7 !important;
    border-radius: 6px;
    padding: 12px 20px;
    text-transform: none;
    margin-left: 10px;
    cursor: pointer;

    .title-btn {
      color: #1A202C;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .v-btn__content {
      display: flex;
      align-items: center;
      column-gap: 8px;
    }

    .icon-arrow {
      transition: transform 0.3s ease;

      &.rotate {
        transform: rotate(90deg);
      }
    }
  }

  .dropdown-list {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    padding: 14px 12px;

    .button {
      ::v-deep .v-btn {
        border-radius: 0;
        background-color: transparent;
        padding: 10px;
        width: 100%;
        display: flex;
        justify-content: flex-start;
      }

      .title-btn {
        color: #1A202C;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        padding-left: 12px;
      }
    }
  }

  @media (max-width: 960px) {
    .user-info-panel {
      flex-direction: column;
      row-gap: 10px;

      & > div {
        flex: 0 0 100%;
        max-width: 100%;
      }

      .visit-info {
        & > div {
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          justify-content: space-between;
          flex-wrap: nowrap;

          .button {
            display: flex;
            justify-content: flex-end;
            width: auto !important;
            flex: 1 1 auto;
          }

          ::v-deep .v-btn {
            max-width: 330px;
          }
        }
        &__text {
          margin: 0 !important;
        }
      }
    }

    .btn-survey {
      .text {
        display: none;
      }
    }

    .blood-draw-date__label {
      display: none;
    }
  }
</style>
